import store from "@/store";

const routes = [
    {
        path: "/hr/leave-types/:id",
        name: "hrLeaveTypes",
        component: () => import('@/views/main/modules/HR/LeaveTypes/LeaveTypesComponent.vue'),
        beforeEnter: (to, from, next) => {
            store.dispatch('checkAccessUser', to.params.id).then((response) => {
                if (response == 'fail') {
                    next('/no-access')
                } else {
                    next()
                }
            }).catch(() => {
                next('/no-access')
            })
        },
        meta: {
            requiresAuth: true,
            title: 'Leave Types',
        }
    },
    {
        path: "/hr/leave-applications/:id",
        name: "hrLeaveApplications",
        component: () => import('@/views/main/modules/HR/LeaveApplications/LeaveApplicationsComponent.vue'),
        beforeEnter: (to, from, next) => {
            store.dispatch('checkAccessUser', to.params.id).then((response) => {
                if (response == 'fail') {
                    next('/no-access')
                } else {
                    next()
                }
            }).catch(() => {
                next('/no-access')
            })
        },
        meta: {
            requiresAuth: true,
            title: 'Leave Applications',
        }
    },
    {
        path: "/hr/leave-calendar/:id",
        name: "hrLeaveCalendar",
        component: () => import('@/views/main/modules/HR/LeaveApplications/LeaveCalendarComponent.vue'),
        beforeEnter: (to, from, next) => {
            store.dispatch('checkAccessUser', to.params.id).then((response) => {
                if (response == 'fail') {
                    next('/no-access')
                } else {
                    next()
                }
            }).catch(() => {
                next('/no-access')
            })
        },
        meta: {
            requiresAuth: true,
            title: 'Leave Calendar',
        }
    }
]

export default routes;

